export var ExpiryStatus = {
  Invalid: 1,
  InvalidIfStale: 2,
  Valid: 3
};